// Subscribes to SyncChannel via Action Cable to keep window.contacts/projects/tasks
// arrays in sync when other tabs create, update, or remove records.
export default class SyncObserver {
  constructor(accountId, userId) {
    this.accountId = accountId;
    this.userId = userId;
  }

  connect() {
    this.subscription ??= App.cable.subscriptions.create({
      channel: "SyncChannel",
      account_id: this.accountId
    }, {
      received: (data) => this.received(data)
    });
  }

  received(data) {
    const arrays = { contact: window.contacts, project: window.projects, task: window.tasks };

    for (const [type, arr] of Object.entries(arrays)) {
      const record = data[type];
      if (!record || !arr) continue;

      switch (data.action) {
        case 'created':
          if (!arr.find(r => r.id === record.id)) arr.push(record);
          break;
        case 'updated': {
          const idx = arr.findIndex(r => r.id === record.id);
          if (idx !== -1) Object.assign(arr[idx], record);
          break;
        }
        case 'removed': {
          const idx = arr.findIndex(r => r.id === record.id);
          if (idx !== -1) arr.splice(idx, 1);
          break;
        }
      }
    }
  }
}

window.SyncObserver = SyncObserver;
